import EmergencySignIn from "./EmergencySignIn";

export default EmergencySignIn;
